/**
 * Category-map rows for a lens by prime/zoom and focal-range class (flag `lens_focal_range`,
 * MOT-452). Keep in sync with `LENS_FOCAL_CATEGORY_KEYS` in `src/utils/lensFocalRange.ts`;
 * `src/__tests__/lensFocalRange.test.ts` pins the two lists together.
 */
export const LENS_FOCAL_CATEGORY_KEYS: readonly string[] = [
  'prime-wide-angle',
  'prime-standard',
  'prime-telephoto',
  'zoom-wide-angle',
  'zoom-standard',
  'zoom-telephoto',
  'zoom-superzoom',
];

export const isLensFocalCategoryKey = (slug: string): boolean => LENS_FOCAL_CATEGORY_KEYS.includes(slug);
